import React, { useCallback } from 'react';

import { Checkbox } from '@vtblife/uikit';
import { RenovationProgram } from '@search/filter-enums/enums';

import { RenovationProgramFilter } from '../../../../models/Filter';

interface IRenovationProgramButtonFilterView {
    filter: RenovationProgramFilter;
    handleChange: (filter: RenovationProgramFilter) => void;
}

export const RenovationProgramButtonFilterView: React.FC<IRenovationProgramButtonFilterView> = ({
    filter,
    handleChange,
}) => {
    const onChange = useCallback((newValue: boolean) => {
        if (newValue) {
            handleChange(new RenovationProgramFilter(RenovationProgram.HAS_ANY));
        } else {
            handleChange(new RenovationProgramFilter());
        }
    }, [ handleChange ]);

    return (
        <div style={{ width: 'max-content' }}>
            <Checkbox
                name='renovationProgram'
                value={filter.willRenovation === RenovationProgram.HAS_ANY}
                onChange={onChange}
                variant='filter'
                block
            >
                Дом под реновацию
            </Checkbox>
        </div>
    );
};
